import { useState } from 'react';

export default function Home() {
  const [activeModule, setActiveModule] = useState('overview');

  const modules = [
    {
      id: 'business-setup',
      title: '企业开办',
      icon: 'ri-building-line',
      description: '通过广州市开办企业一网通平台进行企业注册、变更、注销等服务',
      color: 'bg-blue-500'
    },
    {
      id: 'tax-agency',
      title: '财税代理',
      icon: 'ri-calculator-line',
      description: '税务申报、财务代理、税收筹划等服务',
      color: 'bg-green-500'
    },
    {
      id: 'qualification-permit',
      title: '资质许可',
      icon: 'ri-award-line',
      description: '各类行业资质申请与许可证办理',
      color: 'bg-purple-500'
    },
    {
      id: 'registered-address',
      title: '挂靠地址',
      icon: 'ri-map-pin-line',
      description: '企业注册地址挂靠服务',
      color: 'bg-orange-500'
    },
    {
      id: 'policy-subsidy',
      title: '政策补贴',
      icon: 'ri-government-line',
      description: '政府补贴政策咨询与申请指导',
      color: 'bg-red-500'
    }
  ];

  const trainingSteps = [
    {
      step: '1',
      title: '基础知识学习',
      description: '了解各业务板块的基本概念和服务范围'
    },
    {
      step: '2',
      title: '政务平台熟悉',
      description: '掌握广州市政务服务网和广东省政务服务网操作流程'
    },
    {
      step: '3',
      title: '客户沟通技巧',
      description: '学习如何精准引导客户，提供专业咨询'
    },
    {
      step: '4',
      title: '实战演练',
      description: '通过案例分析和模拟对话提升服务能力'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">企服培训平台</h1>
              <p className="text-lg text-gray-600 mt-2">天建产业服务</p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="bg-blue-100 px-4 py-2 rounded-full">
                <span className="text-blue-800 font-medium">培训进度: 0%</span>
              </div>
              <button className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap">
                开始学习
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/0b396a5cafc3c918161cd4f14a2853f3.jpg')`
          }}
        >
          <div className="absolute inset-0 bg-blue-900/70"></div>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-5xl font-bold text-white mb-6">
            全面掌握企业服务核心业务
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            本培训旨在帮助客服团队全面掌握广州市企业服务的五大核心业务板块，结合政务服务网操作流程，提供专业高效的服务支持
          </p>
          <div className="flex justify-center space-x-4">
            <button className="bg-white text-blue-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
              立即开始培训
            </button>
            <button className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors cursor-pointer whitespace-nowrap">
              查看课程大纲
            </button>
          </div>
        </div>
      </section>

      {/* Business Modules */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">五大核心业务板块</h3>
            <p className="text-lg text-gray-600">全面覆盖广州市企业服务主要领域</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {modules.map((module, index) => (
              <div 
                key={module.id} 
                className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden group cursor-pointer"
                onClick={() => {
                  if (module.id === 'business-setup') {
                    window.REACT_APP_NAVIGATE('/business-setup');
                  } else if (module.id === 'tax-agency') {
                    window.REACT_APP_NAVIGATE('/tax-agency');
                  } else if (module.id === 'qualification-permit') {
                    window.REACT_APP_NAVIGATE('/qualification-permit');
                  } else if (module.id === 'policy-subsidy') {
                    window.REACT_APP_NAVIGATE('/policy-subsidy');
                  } else if (module.id === 'registered-address') {
                    window.REACT_APP_NAVIGATE('/registered-address');
                  }
                }}
              >
                <div className={`${module.color} h-2`}></div>
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <div className={`w-12 h-12 ${module.color} rounded-lg flex items-center justify-center mr-4`}>
                      <i className={`${module.icon} text-white text-xl`}></i>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900">{module.title}</h4>
                  </div>
                  <p className="text-gray-600 mb-4">{module.description}</p>
                  {module.id === 'business-setup' && (
                    <div className="bg-blue-50 p-3 rounded-lg mb-4">
                      <p className="text-sm text-blue-800 font-medium">核心平台：广州市开办企业一网通</p>
                      <p className="text-xs text-blue-600 mt-1">支持PC端和微信小程序办理</p>
                    </div>
                  )}
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-500">课程时长: 2小时</span>
                    <span className="text-blue-600 font-medium group-hover:text-blue-800">开始学习 →</span>
                  </div>
                </div>
              </div>
            ))}
            
            {/* Special Module for Government Platforms */}
            <div 
              className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden text-white cursor-pointer"
              onClick={() => window.REACT_APP_NAVIGATE('/government-platform')}
            >
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-global-line text-white text-xl"></i>
                  </div>
                  <h4 className="text-xl font-bold">政务平台操作</h4>
                </div>
                <p className="text-indigo-100 mb-4">广东政务服务网、广州市政务服务网等平台使用指南</p>
                <div className="bg-white/10 p-3 rounded-lg mb-4">
                  <p className="text-sm font-medium">包含：登录认证、业务办理、材料上传等</p>
                  <p className="text-xs text-indigo-200 mt-1">支持一网通办、全程网办</p>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-indigo-200">课程时长: 1.5小时</span>
                  <span className="text-white font-medium">开始学习 →</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Training Process */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">培训流程</h3>
            <p className="text-lg text-gray-600">系统化培训，全面提升服务能力</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {trainingSteps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-white text-xl font-bold">{step.step}</span>
                  </div>
                  {index < trainingSteps.length - 1 && (
                    <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-blue-200 -ml-8"></div>
                  )}
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{step.title}</h4>
                <p className="text-gray-600">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">培训特色</h3>
            <p className="text-lg text-gray-600">专业、实用、高效的培训体系</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-blue-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">实用性强</h4>
              <p className="text-gray-600">贴近实际工作场景，结合真实案例进行教学</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-team-line text-green-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">专业师资</h4>
              <p className="text-gray-600">经验丰富的政务服务专家和资深客服培训师</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-lightbulb-line text-purple-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">互动式学习</h4>
              <p className="text-gray-600">模拟对话、角色扮演等多种互动学习方式</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-time-line text-orange-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">灵活安排</h4>
              <p className="text-gray-600">在线学习，自主掌握学习进度和时间安排</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-certificate-line text-red-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">认证体系</h4>
              <p className="text-gray-600">完成培训可获得专业客服能力认证证书</p>
            </div>
            
            <div className="text-center p-6">
              <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-refresh-line text-indigo-600 text-2xl"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">持续更新</h4>
              <p className="text-gray-600">根据政务服务政策变化及时更新培训内容</p>
            </div>
          </div>
        </div>
      </section>

      {/* Platform Details */}
      <section className="py-16 bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">主要政务平台</h3>
            <p className="text-lg text-gray-600">掌握核心政务服务平台操作要点</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-government-line text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-gray-900">广东政务服务网</h4>
                  <p className="text-gray-600">省级统一政务服务平台</p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">全省政务服务事项统一办理</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">支持个人和企业用户注册</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">提供移动端"粤省事"小程序</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">材料电子化、流程标准化</span>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-8">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-building-line text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-2xl font-bold text-gray-900">广州市开办企业一网通</h4>
                  <p className="text-gray-600">企业开办专门平台</p>
                </div>
              </div>
              <div className="space-y-4">
                <div className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">企业开办全流程网上办理</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">支持营业执照、印章、银行开户同步办理</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">提供微信小程序移动办理</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-3"></i>
                  <span className="text-gray-700">1-2个工作日内完成审批</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Business Process Details */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-4">业务办理要点</h3>
            <p className="text-lg text-gray-600">掌握关键环节，提供专业指导</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-user-settings-line text-white text-xl"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3">实名认证要点</h4>
              <ul className="text-sm text-gray-700 space-y-2">
                <li>• 确保身份证信息清晰可见</li>
                <li>• 手机号码必须为本人实名</li>
                <li>• 人脸识别环境光线充足</li>
                <li>• 避免佩戴口罩或帽子</li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-file-upload-line text-white text-xl"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3">材料上传规范</h4>
              <ul className="text-sm text-gray-700 space-y-2">
                <li>• 图片格式：JPG、PNG、PDF</li>
                <li>• 文件大小不超过5MB</li>
                <li>• 保证图片清晰度和完整性</li>
                <li>• 避免反光和阴影影响</li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-6">
              <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-900 mb-3">常见问题处理</h4>
              <ul className="text-sm text-gray-700 space-y-2">
                <li>• 网络超时：刷新页面重试</li>
                <li>• 验证码错误：检查输入法状态</li>
                <li>• 审核被退回：仔细查看退回原因</li>
                <li>• 材料补正：按要求重新上传</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-semibold mb-4">联系我们</h4>
              <div className="space-y-2 text-gray-300">
                <p>电话: 020-1234-5678</p>
                <p>邮箱: training@example.com</p>
                <p>地址: 广州市天河区xxx路123号</p>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">快速链接</h4>
              <div className="space-y-2 text-gray-300">
                <p className="cursor-pointer hover:text-white">培训课程</p>
                <p>学习资料</p>
                <p>在线考试</p>
                <p>证书查询</p>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">政务平台</h4>
              <div className="space-y-2 text-gray-300">
                <p>广东政务服务网</p>
                <p>广州市政务服务网</p>
                <p>广州市开办企业一网通</p>
                <p>国家企业信用信息公示系统</p>
              </div>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4">企业服务</h4>
              <div className="space-y-2 text-gray-300">
                <p>企业开办</p>
                <p>财税代理</p>
                <p>资质许可</p>
                <p>政策补贴</p>
                <p><a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors">Made with Readdy</a></p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 客户培训平台. 保留所有权利.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}